import React ,{ useEffect } from 'react';

const DisableInspect = () => {
  useEffect(() => {
      document.addEventListener('contextmenu', (e) => e.preventDefault());

    // Disable key shortcuts
    const disableShortcuts = (e) => {
      if (
        e.keyCode === 123 || // F12
        (e.ctrlKey && e.shiftKey && e.keyCode === 73) ||  
        (e.ctrlKey && e.shiftKey && e.keyCode === 74) || // Ctrl+Shift+J
        (e.ctrlKey && e.keyCode === 85) // Ctrl+U
      ) {
        e.preventDefault();
        return false;
      }
    };
    document.addEventListener('keydown', disableShortcuts);

    // Cleanup event listeners
    return () => {
      document.removeEventListener('contextmenu', (e) => e.preventDefault());
      document.removeEventListener('keydown', disableShortcuts);
      
    };
  }, []);
  
  return null;
};

export default DisableInspect;
